import { takeLatest, put, call } from 'redux-saga/effects';
import { getContent } from '../../../api/getContent';
import { APIContentResponse, APIContentRequest } from '../../../api/types';
import { fetchTrainings } from './actions';

export function* fetchTrainingsSaga({ payload }: { payload: APIContentRequest }) {
  yield put(fetchTrainings.processing());
  try {
    const response: APIContentResponse = yield call(getContent, payload);
    yield put(fetchTrainings.success(response));
  } catch (err) {
    yield put(fetchTrainings.failed(err as Error));
  }
}

export function* trainingsListSaga() {
  yield takeLatest(fetchTrainings.request, fetchTrainingsSaga);
}
